<template>
  <div class="pivo-auth-verify">
    <Spin size="large" fix v-if="started"></Spin>
    <template v-else>
    <!--- <img src="https://app.youvr.io/assets/images/logos/youvr-logo-01.png"> -->
    <!-- <img src="/logo.webp"> -->
      <div class="description" v-if="verified">
        <Icon type="md-checkmark-circle" />
        <br>
        <h2>Success!</h2>
        <br>
        <span v-t="'verify.success'"></span>
      </div>
      <div class="description" v-else>
        <Icon type="md-sad" />
        <br>
        <h2>Sorry!</h2>
        <br>
        <span v-t="'verify.fail'"></span>
      </div>
    </template>
  </div>
</template>

<script>
import api2 from '../../api';

export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      started: false,
      verified: false
    };
  },

  async mounted() {
    this.started = true;
    try {
      const resp = await api2.verify(this.id);
      if (!resp) {
        throw new Error('error with verify api resp!');
      }
      if (Object.keys(resp).length < 1) {
        this.verified = true;
      } else {
        this.verified = false;
      }
    } catch (e) {
      // this.$Message.error(e.message);
    } finally {
      this.started = false;
    }
  },

  methods: {
  }
};
</script>

<style lang="less" scoped>
.pivo-auth-verify {
  padding: 30px;
  text-align: center;
  background-color: hsla(0, 0%, 20%, 0.5);
  border-radius: 5px;
  color: white;

  .description {
    margin-bottom: 30px;
    font-size: 18px;

    i {
      font-size: 48px;
    }
  }
}
</style>
